import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { EnergySavingIcon } from '~/icons';
import { BoxEconomyMode } from '../styles';

interface ManualMode {
  isOpen: boolean;
  onClose: () => void;
  onTurnOffEconomyMode?: () => void;
}

export const ModalManualMode: React.FC<ManualMode> = ({ isOpen, onClose, onTurnOffEconomyMode }) => {
  const { t } = useTranslation();
  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      text={t('modoManualInfo')}
      title={t('modoManual')}
      iconTitle={<></>}
      button1={t('fechar')}
      button1Action={onClose}
      imageText={(
        <BoxEconomyMode onClick={onTurnOffEconomyMode} data-testid="controle_inteligente-tag-desligar_modo_economia-modo_economia-ativado">
          <div>
            <EnergySavingIcon />
            {t('desligarModoEconomia')}
          </div>
        </BoxEconomyMode>
      )}
    />
  );
};
